import Component from '@cell/cell-core/component/component';

import './collection-description.scss';

class CollectionDescription extends Component {
  constructor() {
    super();

    this.elements = {
      text: this.querySelector('.Text'),
    };

    this.expanded = undefined;

    this.handleToggleExpandClick = this.handleToggleExpandClick.bind(this);
  }

  componentDidMount() {
    // If the content is taller than the container, collapse it by default and add logic to toggle
    // between collapsed and expanded states.
    if (this.elements.text.scrollHeight > this.elements.text.clientHeight) {
      this.setAttribute('aria-expanded', 'false');

      this.expanded = false;

      this.on('c-button.click.toggle-expand', this.handleToggleExpandClick);
    }
  }

  handleToggleExpandClick() {
    if (this.expanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.setAttribute('aria-expanded', 'true');

    this.expanded = true;
  }

  collapse() {
    this.setAttribute('aria-expanded', 'false');

    this.expanded = false;
  }
}

customElements.define('collection-description', CollectionDescription);
